var map = {
	"./10-12-2020-v2/1024/img/env.png": "17fc",
	"./10-12-2020-v2/2048/img/env.png": "3878",
	"./10-12-2020-v2/512/img/env.png": "66df",
	"./10-12-2020-v3/1024/img/env.png": "e25d",
	"./10-12-2020-v3/2048/img/env.png": "714c",
	"./10-12-2020-v3/512/img/env.png": "86d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9be";